<template>
  <div class="c-card elevation-2">
    <v-layout align-center class="subheading pl-3 pr-3 crx-toolbar">
      Production
      <v-spacer></v-spacer>
      <v-menu offset-y
      :close-on-content-click="false">
        <template v-slot:activator="{ on }">
          <v-btn
          text
          small
          v-on="on"
          >
            <span >{{ ((page - 1) * rowsPerPage) + 1 }}-{{ Math.min(page * rowsPerPage, searchMatches.length) }} of {{ searchMatches.length }}</span>
          </v-btn>
        </template>
        <v-card class="pa-2">
          <span class="caption">Items per page</span>
          <v-text-field
          v-model="rowsPerPageTV"
          hide-details
          style="max-width: 70px;"
          solo></v-text-field>
        </v-card>
      </v-menu>
    </v-layout>

    <template v-if="items.length > 0">

      <v-layout>
        <v-spacer></v-spacer>
        <!-- filter menu -->
        <v-menu 
        bottom
        left
        transition="slide-y-transition"
        offset-y>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              text
              small
              v-on="on"
            >
              <v-icon color="text">filter_list</v-icon>
            </v-btn>
          </template>

          <v-list>
            <v-item-group 
            v-model="sortIndex"
            mandatory>
              <v-item
                v-for="(n, index) in sortOptions"
                :key="n">
                <v-list-tile
                  v-ripple
                  slot-scope="{ active }"
                  :selected="active"
                  @click="clickSortHeader(index)"
                >
                  {{ n }}
                  <v-icon 
                  small
                  color="color1"
                  :class="['sort-arrow', {'rotate': active && sortAscending}, {'visible': active }]">
                    arrow_downward
                  </v-icon>
                </v-list-tile>
              </v-item>
            </v-item-group>
          </v-list>
        </v-menu>
        <!-- end filter menu -->
      </v-layout>

      <div>
        <production-row
        v-for="item in paginatedArray" 
        :key="item.tempID"
        :item="item">
        </production-row>
      </div>
      <div class="text-xs-center">
        <v-pagination
        v-if="paginationLength > 1"
        v-model="page"
        :length="paginationLength"
        circle>

        </v-pagination>

      </div>

    </template>

    <v-layout
    v-else
    align-center
    justify-center
    style="height: 100%;">

      <div class="title font-weight-regular text-xs-center pa-4">
        <img class="c-align-self-start" src="@/assets/img/illustrations/production.png" alt="cardboard box" width="56px">
        <div class="mt-3">
          Not used in any productions.
        </div>
      </div>
    </v-layout>

    <!-- BOT TOOLBAR -->
    <div class="c-hr"></div>
    <v-layout align-center class="subheading pl-3 pr-3 crx-toolbar">
      Total used in production:&nbsp;
      <c-metric-selector
      :inventoryItemID="inventoryItemID" 
      :realValue="totalUsedInProduction"
      labelMode
      :key="inventoryItemID"
      alwaysScale
      ></c-metric-selector>
    </v-layout>
  </div>
</template>

<script>
import axios from 'axios'
import ListController from '@/mixins/ListController'
import ProductionRow from './production-row'

export default {
  props: ['id', 'inventoryItemID'],
  mixins: [ListController],
  components: {
    ProductionRow
  },
  data () {
    return {
      rowsPerPage: 5,
      rowsPerPageTV: 5,
      sortOptions: [
        'ID', 'Date'
      ],
      sortIndex: 1,
      sortAscending: true
    }
  },
  computed: {
    totalUsedInProduction () {
      return this.items.reduce((a, i) => {
        return a + i.quantity
      }, 0)
    }
  },
  methods: {
    sort (headerIndex, items, sortAscending) {
      if (headerIndex === 0) { // ID
        return items.sort((a, b) => {
          return sortAscending ? a.id - b.id : b.id - a.id
        })
      } else if (headerIndex === 1) { // Date
        return items.sort((a, b) => {
          return sortAscending ? new Date(b.date_end) - new Date(a.date_end) : new Date(a.date_end) - new Date(b.date_end)
        })
      }
    },
    fetchData () {
      axios.all([
        this.$axios.get('/production-inputs/archive-id/' + this.id)
      ])
      .then(axios.spread((sales) => {
        this.items = sales.data
      }))
      .catch(error => this.$root.$errorSnackbar(error))
      .then(() => this.snackbarLoading = false)
    }
  },
  created () {
    this.fetchData()
  }
}
</script>

